import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpLoaderFactory } from 'app/app.module';

import { VerticalLayout1Module } from 'app/layout/vertical/layout-1/layout-1.module';



@NgModule({
    imports: [
        VerticalLayout1Module,
    ],
    exports: [
        VerticalLayout1Module
    ]
})
export class LayoutModule {
}
